import AppHeader from '../AppHeader'

export default {
  name: 'propose-detail',
  created () {
    this.search()
  },
  data () {
    return {
      callbackflg: false,
      goodPushing: false
    }
  },
  computed: {
    proposeDetail () {
      return this.$store.getters.proposeDetail
    },
    joint1User () {
      return this.$store.getters.joint1User
    },
    joint2User () {
      return this.$store.getters.joint2User
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      const min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      const sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    getNewGoodsCount () {
      return this.$store.getters.newGoodsCount
    },
    getNewGoodId () {
      return this.$store.getters.newGoodId
    },
    isAdopt () {
      if (this.proposeDetail.attributes['adopt-rank']) {
        return true
      }
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      const self = this
      const data = {}
      const callback = function () {
        self.callbackflg = true
      }
      this.$store.dispatch('PROPOSE_DETAIL', {id: this.$route.params.id, data: data, callback: callback})
    },
    content: function (word) {
      word = word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
      const reUrl = /((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?)/gi
      word = word.replace(reUrl, '<a href="$1" target="_blank" style="color: #337ab7">$1</a>').replace(/\r?\n/g, '<br>')
      return word
    },
    goProfileDetail: function (userId) {
      window.sessionStorage.setItem('profile_detail_referrer', this.$router.history.current.path)
      this.$router.push('/profile/' + userId)
    },
    goBack: function () {
      if (window.sessionStorage.getItem('propose_detail_referrer')) {
        const referrer = window.sessionStorage.getItem('propose_detail_referrer')
        window.sessionStorage.removeItem('propose_detail_referrer')
        this.$router.push({path: referrer})
      } else {
        this.$router.go(-1)
      }
    },
    getGoodClass: function (goodId) {
      return goodId ? '-on' : ''
    },
    toggleGood: function (proposeId) {
      if (!this.goodPushing) {
        this.goodPushing = true
        const goodId = this.getGoodId(proposeId)
        if (goodId) {
          const self = this
          const data = {
            propose_id: proposeId
          }
          const callback = function () {
            self.setGoodId('', self.getNewGoodsCount)
            self.goodPushing = false
          }
          this.$store.dispatch('GOOD_DELETE', {id: goodId, data: data, callback: callback})
        } else {
          const self = this
          const data = {
            propose_id: proposeId
          }
          const callback = function () {
            self.setGoodId(self.getNewGoodId, self.getNewGoodsCount)
            self.goodPushing = false
          }
          this.$store.dispatch('GOOD_CREATE', {id: goodId, data: data, callback: callback})
        }
      }
    },
    getGoodId: function () {
      return this.proposeDetail.attributes['good-id']
    },
    setGoodId: function (goodId, goodsCount) {
      this.proposeDetail.attributes['good-id'] = goodId
      this.proposeDetail.attributes['goods-count'] = goodsCount
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-detail.js